var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 68,
    viewBox: "0 0 43 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_2777_3292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9652 66.4924C12.8533 69.5929 4.91632 61.8417 4.91632 47.1145C4.91632 32.3873 4.12261 22.3108 7.29742 17.6601C10.4722 13.0094 19.203 7.58353 23.9652 8.35865C28.7274 9.13376 35.0771 10.684 37.4582 16.8849C39.8393 27.7366 39.0456 62.6168 23.9652 66.4924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9403 66.3956L23.9383 66.3961C18.4117 67.9382 13.6886 66.78 10.3447 63.4183C6.99655 60.0524 5.01632 54.4625 5.01632 47.1145C5.01632 44.5076 4.99148 42.0476 4.96817 39.7383C4.92558 35.52 4.88807 31.8042 5.01623 28.6126C5.2147 23.6701 5.81053 20.0155 7.38001 17.7164C8.95626 15.4074 11.9193 12.8975 15.0862 11.0612C16.6686 10.1436 18.2987 9.3962 19.8276 8.92658C21.358 8.45653 22.7798 8.26702 23.9491 8.45735C28.7125 9.23264 35.0011 10.7766 37.3621 16.9137C38.5481 22.3276 38.9445 33.7418 37.1612 44.288C36.2692 49.5629 34.8331 54.6134 32.6824 58.5846C30.5316 62.5562 27.673 65.4363 23.9403 66.3956Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3292",
    x: 0.828125,
    y: 0.28418,
    width: 41.6484,
    height: 66.8848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3292",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth34);
export default __webpack_public_path__ + "static/media/teeth34.01a2a1e2193cf427f920f4b339c79818.svg";
export { ForwardRef as ReactComponent };